<template>
    <div class="home">
        <router-link to="/internal_orders" class="is-pulled-right"><button class="button is-info is-small">Back to Orders </button></router-link><br /><br />
        <div class="box">	
              
            
            <form @submit.prevent="saveOrder">
                
                <div class="field">
                          <label class="label">Product</label>
                          <div class="control">
                              <select class="input" v-model="internal_product_id"  required autofocus>
                                <option value="">Please select ...</option>
                                <option :value="row.id" v-for="row in internal_products" :key="row.id">{{ row.name }}</option>
                            </select>
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Description </label>
                          <div class="control">
                              <input class="input" type="text" v-model="description"  >
                             
                          </div>
                      </div>
      
                      <div class="field">
                          <label class="label">Order Date </label>
                          <div class="control">
                              <input class="input" type="date" v-model="date" required >
                             
                          </div>
                      </div>
                    
                      <div class="field">
                          <label class="label">Quantity </label>
                          <div class="control">
                              <input class="input" type="number" v-model="quantity" min="1" step="1" required @keypress="isNumber($event)">
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Unit Price </label>
                          <div class="control">
                              <input class="input" type="number" v-model="unit_price" min="0.01" step="any"  required >
                             
                          </div>
                      </div>

                      
      
                      <div class="field is-grouped">
                          <div class="control">
                              <button class="button is-success" :disabled="working===true">Save Order</button>
                          </div>
                      </div>
                  </form>
            
          </div>
          
      </div>
  </template>

<script>
    import OrderService from '@/services/OrderService.js';
    import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddStone',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    internal_products: [],
                    internal_product_id: '',
                    description: '',
                    quantity: '',
                    unit_price: '',
                    date: this.getStartDate(),
                    working:false
                    
                    
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
               this.getInternalProducts();
            });
          
        },
        methods: {
            
            async getInternalProducts() {
                UtilityService.getSimpleApiData(this.accessToken, "internal_products").then(
                    response => this.internal_products = response 
                );
                
            },
            isNumber: function(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            async saveOrder() {
                this.working = true
                var formdata = { 
                    description : this.description,
                    internal_product_id : this.internal_product_id,
                    date : this.date,
                    quantity : this.quantity,
                    unit_price : this.unit_price
                }; 

                OrderService.saveInternalOrder(this.accessToken, formdata)
                .then((response) => {
                    this.$router.push("/finance/internal-orders");
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },
            getStartDate() {
            
                var d = new Date();
                
                d.setDate(d.getDate() );
                return d.toISOString().slice(0,10);
                
            },
           
        }
    }
    </script>